import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Table, Button } from 'reactstrap';

export const OrderDetailsModal = ({ isOpen, toggle, orderDetails }) => {
  // Calculate subtotal
  const subtotal = orderDetails?.menuOrderDetails?.reduce((acc, item) => acc + item.quantity * item.price, 0) || 0;
  
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Order Details</ModalHeader>
      <ModalBody>
        {orderDetails && orderDetails.menuOrderDetails.length > 0 ? (
          <Table striped>
            <thead>
              <tr>
                <th>Item</th>
                <th>Quantity</th>
                <th>Price</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {orderDetails.menuOrderDetails.map((item) => (
                <tr key={item.menuOrderDetailId}>
                  <td>
                    <img width={50} height={50} className='object-fit-cover' src={item.menuItemDetail.cloudR2ImagePath.getCDNUrl()} alt={item.menuItemDetail.title} />
                   &nbsp; {item.menuItemDetail.title}
                  </td>
                  <td>{item.quantity}</td>
                  <td>{item.price} {item.menuItemDetail.currency}</td>
                  <td>{item.quantity * item.price} {item.menuItemDetail.currency}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <th colSpan="2"></th>
                <th  className="text-right">Sub Total:</th>
                <th>{subtotal} {orderDetails.menuOrderDetails[0].menuItemDetail.currency}</th>
              </tr>
            </tfoot>
          </Table>
        ) : (
          <p>No items ordered.</p>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};